module.exports = __webpack_public_path__ + "img/icons B_38.522597c9.png";